interface AssetAllocation {
  stocks: number;
  bonds: number;
  cash: number;
  alternatives: number;
}

export const RISK_WEIGHTS = {
  stocks: 5,
  bonds: 2,
  cash: 1,
  alternatives: 4,
} as const;

export const calculateRiskScore = (allocations: AssetAllocation): number => {
  const { stocks, bonds, cash, alternatives } = allocations;
  const score = (
    stocks * RISK_WEIGHTS.stocks +
    bonds * RISK_WEIGHTS.bonds +
    cash * RISK_WEIGHTS.cash +
    alternatives * RISK_WEIGHTS.alternatives
  ) / 100;
  
  return Number(score.toFixed(1));
};

export const getRiskProfile = (score: number) => {
  if (score <= 1.0) return { label: "CAUTIOUS", color: "bg-blue-100 text-blue-800" };
  if (score <= 2.0) return { label: "CONSERVATIVE", color: "bg-green-100 text-green-800" };
  if (score <= 3.0) return { label: "MODERATE", color: "bg-yellow-100 text-yellow-800" };
  if (score <= 4.0) return { label: "AGGRESSIVE", color: "bg-orange-100 text-orange-800" };
  return { label: "SPECULATIVE", color: "bg-destructive/10 text-destructive" };
};